const body = document.querySelector("body");
const header = document.querySelector('header');
const headerWrapper = document.querySelector("header .wrapper-top");

window.addEventListener('DOMContentLoaded', ()=> {
    burgerShowMenu();
    translateShowSelection();
})

window.addEventListener('load', ()=> {
    headerSettings();
    bodyPadding();
})

window.addEventListener('resize', ()=>{
    headerSettings();
    setTimeout(() => {
        bodyPadding()
    }, 600);
})

function bodyPadding() {
    body.style.paddingTop = headerWrapper.clientHeight + "px";
}

function headerSettings() {
    window.addEventListener('scroll', ()=> {
        if (window.scrollY > 50) {
            header.classList.add('min');
        }
        else{
            header.classList.remove('min');
            setTimeout(() => {
                bodyPadding()
            }, 600);
        }
    })
}

function burgerShowMenu() {
    const burger = document.querySelector('.burger');
    const navigation = document.querySelector('.nav-main ul');

    burger.addEventListener('click', () => {
        burger.classList.toggle("open");
        navigation.classList.toggle('open');
    })
}

function translateShowSelection() {
    const translateIco = header.querySelector(".change-language");
    const translatesItems = translateIco.querySelectorAll(".list-wrapper a" );
    if (!localStorage.getItem('lang')) {
        localStorage.setItem('lang', "English");
    }

    chsngeCurrentLang(translatesItems, localStorage.getItem('lang'));

    translateIco.addEventListener('click', function() {
        translateIco.classList.toggle('show');
    })

    translatesItems.forEach(element => {
        element.addEventListener('click', function() {
            localStorage.setItem('lang', element.title);
            chsngeCurrentLang(translatesItems, localStorage.getItem('lang'));
        })
    });
}

function chsngeCurrentLang(items, title) {
    items.forEach(element => {
        if (element.title == title) {
            element.classList.add("selected");
        }
        else{
            element.classList.remove("selected");
        }
    });
}

jQuery(document).click( function(e){
    if ( !jQuery(e.target).closest('.change-language').length ) {
        document.querySelector(".change-language").classList.remove('show');
    }
    if ( !jQuery(e.target).closest('.burger').length ) {
        document.querySelector("header .burger").classList.remove('open');
        document.querySelector("header .nav-main ul").classList.remove('open');
    }
});